import { brandConfigMap, getBrandConfig } from '@/brand';
import store from '@/store';
import { Brands } from '@/brand/brandConfig';

export function setBrandConfig() {
  const domain = window.origin;
  const urlParams = new URLSearchParams(window.location.search);
  const network = urlParams.get('nt');

  if (network) setWorldPlayBrands(network);
  else {
    const brandConfig = brandConfigMap.get(domain) ? brandConfigMap.get(domain) : brandConfigMap.get('default');
    store.commit('setBrandConfig', brandConfig);
  }
}

function setWorldPlayBrands(network) {
  let brandConfig;
  if (network === 'MTN') {
    brandConfig = getBrandConfig(Brands.MTNWorldPlaySouthAfticaEnglish);
    console.log('brandConfig', brandConfig);
    store.commit('setBrandConfig', brandConfig);
  }
  if (network === 'Telkom') {
    brandConfig = getBrandConfig(Brands.TelkomWorldPlaySouthAfticaEnglish);
    store.commit('setBrandConfig', brandConfig);
  }
}